import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createFirebase } from 'modules/notifications/actions/createFirebase';
import checkIsMobile, { isInStandaloneMode } from 'shared/utils/checkMobileDevice';

import PermissionsPrompt from './PermissionsPrompt';


export default compose(
  connect((state) => ({
    isMobile: checkIsMobile(),
    isInStandaloneMode: isInStandaloneMode(),
    refreshToken: state.session.refreshToken.value,
    organizationToken: state.auth.organizations.selectedOrganizationToken,
    isAppointmentInfoShown: state.queues.common.appointmentInfo.isAppointmentInfoShown,
  }),
  { createFirebase },
  ),
)(PermissionsPrompt);
